import React from 'react';
import { FormattedMessage } from '@kyruus/intl';

import CardContainer from '../CardContainer/card-container';
import {
  DetailedProviderContent,
  SIMILAR_PROVIDERS
} from '@kyruus/provider-components';
import { TrackingFunction } from '../../lib/tracking-utils';
import messages from '../../lib/messages';
import { AltProvidersHeader, AltProvidersCards } from './styles';

import { withErrorBoundary } from '../ErrorFallback/with-error-boundary';

interface AlternateProvidersProps {
  altProviders: DetailedProviderContent[];
  createAvailabilityUrl: () => string;
  createProviderUrl: () => string;
  track: TrackingFunction;
}

const AlternateProviders = ({
  altProviders = [],
  createAvailabilityUrl,
  createProviderUrl,

  track
}: AlternateProvidersProps): React.ReactElement => {
  return (
    <CardContainer>
      <AltProvidersHeader>
        <FormattedMessage {...messages.altProvidersHeader} />
      </AltProvidersHeader>
      <AltProvidersCards
        createAvailabilityUrl={createAvailabilityUrl}
        createProviderUrl={createProviderUrl}
        providers={altProviders}
        track={track}
        renderType={SIMILAR_PROVIDERS}
      />
    </CardContainer>
  );
};

export default withErrorBoundary(AlternateProviders);
